var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApplyRegularizationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#000000",
    strokeWidth: 0.64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 32",
    id: "Layer_32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55,12.59l-5,5V55H60V17.59ZM58,53H52V48h6Zm-6-7V18.41l3-3,3,3V46Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.57,9H43V5a2,2,0,0,0-2-2H39a2,2,0,0,0-2,2V9H14V5a2,2,0,0,0-2-2H10A2,2,0,0,0,8,5V9H6.43A2.63,2.63,0,0,0,4,11.79V58.21A2.63,2.63,0,0,0,6.43,61H43.57A2.63,2.63,0,0,0,46,58.21V11.79A2.63,2.63,0,0,0,43.57,9ZM39,5h2v6H39ZM10,5h2v6H10ZM44,58.21c0,.47-.26.79-.43.79H6.43c-.17,0-.43-.32-.43-.79V11.79c0-.47.26-.79.43-.79H8a2,2,0,0,0,2,2h2a2,2,0,0,0,2-2H37a2,2,0,0,0,2,2h2a2,2,0,0,0,2-2h.57c.17,0,.43.32.43.79Z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 30,
    x: 10,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 30,
    x: 10,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 30,
    x: 10,
    y: 34
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 30,
    x: 10,
    y: 40
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplyRegularizationIcon);
export default __webpack_public_path__ + "static/media/applyRegularizationIcon.ab87e1c1ed118228d45b718512c3b53f.svg";
export { ForwardRef as ReactComponent };